import { flowTypes } from '@/common/service/page-config';
import { ZOOM_MEETING_SUB_TYPES } from '../common/utils';

export const MIGRATE_FLOW_TYPES = {
    pro2bundle: 'pro2bundle',
    pro2biz: 'pro2biz',
    biz2bundle: 'biz2bundle',
    biz2pro: 'biz2pro',
    bundle2biz: 'bundle2biz',
    bundle2pro: 'bundle2pro',
    pro2prop: 'pro2prop',
    proplusBack2pro: 'proplusBack2pro',
    prop2bundle: 'prop2bundle',
    bundleBack2proplus: 'bundleBack2proplus',
    bizBack2pro: 'bizBack2pro',
    bundleBack2pro: 'bundleBack2pro',
    bundleBack2biz: 'bundleBack2biz',
    proBack2biz: 'proBack2biz',
    proBack2bundle: 'proBack2bundle',
    bizBack2bundle: 'bizBack2bundle'
}

export const UPGRADE_TYPES = [MIGRATE_FLOW_TYPES.pro2bundle, MIGRATE_FLOW_TYPES.pro2biz, MIGRATE_FLOW_TYPES.biz2bundle, MIGRATE_FLOW_TYPES.pro2prop, MIGRATE_FLOW_TYPES.prop2bundle];
export const DOWNGRADE_TYPES = [MIGRATE_FLOW_TYPES.biz2pro, MIGRATE_FLOW_TYPES.bundle2biz, MIGRATE_FLOW_TYPES.bundle2pro];

export const migrationPlanTypes = ({currentEditPlanCategory: current, originEditPlanCategory: origin, nextEditPlanCategory: next}) => {
    console.log(`[migration-plan] =>`, `origin: ${origin} | current: ${current} | next: ${next}`);
    // pro
    if (origin === ZOOM_MEETING_SUB_TYPES.PRO) {
        // pro to biz plus
        if (next === ZOOM_MEETING_SUB_TYPES.ZOOM_ONE_BIZ_PLUS) {
            return MIGRATE_FLOW_TYPES.pro2bundle;
        }
        // pro/biz plus to biz
        if (next === ZOOM_MEETING_SUB_TYPES.BIZ) {
            // pro to biz
            if (current === ZOOM_MEETING_SUB_TYPES.PRO) {
                return MIGRATE_FLOW_TYPES.pro2biz;
            }

            // biz plus to biz
            if (current === ZOOM_MEETING_SUB_TYPES.ZOOM_ONE_BIZ_PLUS) {
                // out of scope
                return MIGRATE_FLOW_TYPES.pro2biz;
            }

            if (current === ZOOM_MEETING_SUB_TYPES.ZOOM_ONE_PRO_PLUS) {
                return MIGRATE_FLOW_TYPES.pro2biz;
            }
        }
        // biz/biz plus back to pro
        if (next === ZOOM_MEETING_SUB_TYPES.PRO) {
            // biz to pro
            if (current === ZOOM_MEETING_SUB_TYPES.BIZ) {
                return MIGRATE_FLOW_TYPES.bizBack2pro;
            }

            // biz plus to pro
            if (current === ZOOM_MEETING_SUB_TYPES.ZOOM_ONE_BIZ_PLUS) {
                // out of scope
                return MIGRATE_FLOW_TYPES.bundleBack2pro;
            }

            if (current === ZOOM_MEETING_SUB_TYPES.ZOOM_ONE_PRO_PLUS) {
                return MIGRATE_FLOW_TYPES.proplusBack2pro;
            }
        }

        if (next === ZOOM_MEETING_SUB_TYPES.ZOOM_ONE_PRO_PLUS) {
            if (current === ZOOM_MEETING_SUB_TYPES.BIZ) {
                return MIGRATE_FLOW_TYPES.pro2prop;
            }
            return MIGRATE_FLOW_TYPES.pro2prop;
        }
    }
    // pro plus
    if (origin === ZOOM_MEETING_SUB_TYPES.ZOOM_ONE_PRO_PLUS) {
        // upgrade to biz plus
        if (next === ZOOM_MEETING_SUB_TYPES.ZOOM_ONE_BIZ_PLUS) {
            return MIGRATE_FLOW_TYPES.prop2bundle;
        }

        if (next === ZOOM_MEETING_SUB_TYPES.ZOOM_ONE_PRO_PLUS) {
            if (current === ZOOM_MEETING_SUB_TYPES.ZOOM_ONE_BIZ_PLUS) {
                return MIGRATE_FLOW_TYPES.bundleBack2proplus;
            }
        }
    }
    // biz
    if (origin === ZOOM_MEETING_SUB_TYPES.BIZ) {
        // biz to biz plus
        if (next === ZOOM_MEETING_SUB_TYPES.ZOOM_ONE_BIZ_PLUS) {
            return MIGRATE_FLOW_TYPES.biz2bundle;
        }
        // biz/biz plus to pro => biz to pro
        if (next === ZOOM_MEETING_SUB_TYPES.PRO) {
            return MIGRATE_FLOW_TYPES.biz2pro;
        }
        // pro back to biz
        if (next === ZOOM_MEETING_SUB_TYPES.BIZ) {
            // biz plus back to biz
            if (current === ZOOM_MEETING_SUB_TYPES.ZOOM_ONE_BIZ_PLUS) {
                return MIGRATE_FLOW_TYPES.bundleBack2biz;
            }
            if (current === ZOOM_MEETING_SUB_TYPES.PRO) {
                return MIGRATE_FLOW_TYPES.proBack2biz;
            }
        }
    }
    // biz plus
    if (origin === ZOOM_MEETING_SUB_TYPES.ZOOM_ONE_BIZ_PLUS) {
        // biz plus to biz
        if (next === ZOOM_MEETING_SUB_TYPES.BIZ) {
            return MIGRATE_FLOW_TYPES.bundle2biz;
        }
        // biz/pro back to biz plus
        if (next === ZOOM_MEETING_SUB_TYPES.ZOOM_ONE_BIZ_PLUS) {
            if (current === ZOOM_MEETING_SUB_TYPES.PRO) return MIGRATE_FLOW_TYPES.proBack2bundle; // out of scope
            if (current === ZOOM_MEETING_SUB_TYPES.BIZ) return MIGRATE_FLOW_TYPES.bizBack2bundle;
        }
        // biz plus to pro
        if (next === ZOOM_MEETING_SUB_TYPES.PRO) {
            // out of scope
            return MIGRATE_FLOW_TYPES.bundle2pro;
        }
    }
}

export const getMigrateFlowType = (type) => {
    if (UPGRADE_TYPES.includes(type)) return flowTypes.upgrade;
    if (DOWNGRADE_TYPES.includes(type)) return flowTypes.downgrade;
    return '';
};
